import iconSearch from "../../assets/icon-search.svg";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export function SearchBar({ value, onChange }: SearchBarProps) {
  return (
    <div className="flex-1 relative">
      <img
        src={iconSearch}
        alt=""
        width={20}
        height={20}
        className="absolute left-4 top-1/2 -translate-y-1/2"
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search"
        className="w-full h-[51px] pl-12 pr-4 rounded-2xl border border-stroke-primary bg-bg-primary text-base text-text-primary placeholder:text-text-tertiary focus:outline-none focus:border-brand-brown"
      />
    </div>
  );
}
